import React from "react";
import { ThemeEnum, ThemeProvider, Toaster } from "@pickit/pickit-components";
import { useTheming } from "config/theme";
import { ConnectedRouter } from "connected-react-router";
import { Provider } from "react-redux";
import Routes from "routes/Routes";
import { store } from "./store";
import { PersistGate } from "redux-persist/integration/react";
import persistStore from "redux-persist/es/persistStore";
import { history } from "reducers";
import NotificationModal from "component/modal/NotificationModal";

const persistor = persistStore(store);

export const App = () => {
  useTheming();
  return (
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <ThemeProvider theme={ThemeEnum.pickers}>
            <PersistGate loading={null} persistor={persistor}>
              <Routes />
              <NotificationModal />
              <Toaster />
            </PersistGate>
        </ThemeProvider>
      </ConnectedRouter>
    </Provider>
  );
};
